export default {
  "session.securityLogout": "Došlo k bezpečnostnímu odhlášení!",
  "session.differentNewPassword": "Nové heslo je shodné se stávajícím heslem!",
  "session.differentPassword": "Nové hesla nejsou shodné!",
  "session.authorizationError": "K této operaci nemáte práva!",
  "messages.error": "Při odesílání dat nastala chyba!",
  "messages.serverError":
    "Server není dostupný, zkuste prosím přihlášení později!",
  "messages.notFound": "Omlouváme se, hledaná stránka neexistuje.",
  "messages.yes": "Ano",
  "messages.no": "Ne",
  "messages.back": "Zpět",
  "messages.close": "Zavřít",
  "messages.filtering": "Filtrovat",
  "messages.clearForm": "Vymazat formulář",
  "messages.list": "Seznam {header}",
  "messages.successSave": "Úspěšně uloženo!",
  "messages.processingError": "Při zpracování nastala chyba!",
  "messages.error500":
    "Omlouváme se, na webu došlo k chybě, zkuste to prosím později.",
  "messages.retryLoading": "Opakovat načtení",
  "messages.print": "Tisk",
  "messages.printOffer": "Nabídka tisku",
  "messages.delete": "Smazat",
  "messages.here": "zde",
  "messages.save": "Uložit",
  "messages.insert": "Vložit",
  "messages.cancel": "Zrušit",
  "messages.showAll": "Rozbalit vše",
  "messages.hideAll": "Sbalit vše",
  "messages.continue": "Pokračovat",
  "messages.calculate": "Spočítat",
  "messages.warning": "Upozornění",
  "messages.confirm": "Potvrzení",
  "messages.formLoadError": "Při načítání formuláře nastala chyba",
  "messages.logOut": "Odhlásit",
  "messages.loggedOut": "Došlo k odhlášení!",
  "messages.chooseDate": "Vyberte datum",
  "messages.validEmail": "Zadejte prosím validní email!",
  "messages.validVariableSymbol":
    "Variabilní symbol musí obsahovat pouze čísla a mít maximální délku 10!",
  "messages.validUnCode":
    "UN číslo musí obsahovat pouze čísla a být o délce 4!",
  "messages.range": "Překročeno povolené rozmezí hodnot od {min} do {max}!",
  "messages.lastWeek": "Poslední týden",
  "messages.lastMonth": "Poslední měsíc",
  "messages.loading": "Načítání",
  "messages.loadAgain": "Načíst znovu",
  "messages.loadError": "Při načítání dat nastala chyba",
  "messages.loadErrorEntity": "Při načítání {what} nastala chyba",
  "messages.errorTitle": "Selhání bylo způsobeno následující chybou:",
  "messages.unknownError": "neznámá chyba",
  "messages.saveFail": "Uložení selhalo",
  "messages.saveFailBut":
    "Úspěšně uloženo, ale {item} nemá vyplněny všechny povinné parametry!",
  "messages.deselectAll": "Odznačit všechny záznamy",
  "messages.selectAll": "Označit všechny záznamy",
  "messages.allCorect": "Všechny zadané hodnoty jsou v pořádku.",
  "messages.someIncorrect":
    "Tento blok obsahuje chybějící nebo chybně zadané hodnoty!",
  "messages.filter": "Filtr",
  "messages.editItem": "editovat záznam",
  "messages.dropItem": "smazat záznam",
  "messages.drop.question": "Opravdu si přejete odstranit tento záznam?",
  "messages.noRoles": "Přístup odepřen",
  "messages.noRoles.info": "Nemáte dostatečné oprávnění pro přístup.",
  "messages.connection.error":
    "Nelze se připojit k serveru, webová aplikace nebude fungovat správně, zkuste to prosím později. Děkujeme.",
  "messages.validAccount": "Zadejte validní zAccount!",
  "messages.search": "Vyhledat",
  "messages.input.required": "Tento údaj je povinný!",
  "messages.maxLength": "Maximální povolená délka je {count} znaků.",
  clientUser: "Informace klient/uživatel",
  "clientUser.info":
    "Zobrazení informací o uživatelích klient a dostupných klientech uživatele.",
  "clientUser.user": "Klienti uživatele",
  "clientUser.client": "Uživatelé klienta",
  "clientUser.accountOrName": "z-account/název klienta",
  "clientUser.username": "uživatelské jméno",
  "clientUser.client.name": "Název",
  "clientUser.client.companyId": "IČO",
  "clientUser.client.account": "z-account",
  "clientUser.client.evoCode": "EVO kód",
  "crud.edit": "{what} byl{suffix} úspěšně upraven{suffix}.",
  "crud.editError": "Při úpravě {whatError} nastala chyba!.",
  "crud.delete": "{what} byl{suffix} úspěšně smazán{suffix}.",
  "crud.deleteError": "Při mazání {whatError} nastala chyba!",
  "footer.fraud": "Informace o podvodech",
  "footer.terms": "Smluvní podmínky",
  "footer.legal": "Právní oznámení",
  "footer.privacy": "Oznámení o ochraně soukromí",
  "footer.conflict": "Řešení sporů",
  "footer.access": "Přístupnost",
  "footer.follow": "Sledujte nás na",
  "footer.version": "verze webové aplikace {version}",
  "footer.rights": "{year} © DHL Freight CZ, s.r.o. Všechna práva vyhrazena.",
  "header.home": "Domů",
  "header.contact": "Kontakt",
  "header.news": "Novinky",
  "header.services": "Služby",
  "header.backToMain": "Přechod na hlavní stránku",
  "menu.newConsignment": "Nová zásilka",
  "menu.newConsignment.new": "Vytvořit",
  "menu.newConsignment.import": "Import dat",
  "menu.newConsignment.template": "Ze šablony",
  "menu.consignmentList": "Přehled zásilek",
  "menu.consignmentList.notSent": "Neodeslané do DHL",
  "menu.consignmentList.sent": "Odeslané do DHL",
  "menu.tracking": "Sledování zásilek",
  "menu.customers": "Seznam zákazníků",
  "menu.calculator": "Kalkulátor ceny",
  "menu.contracts": "Obchodní podmínky a smlouvy",
  "menu.invoices": "Přehled faktur",
  "menu.setting": "Nastavení",
  "menu.setting.users": "Správa uživatelů",
  "menu.setting.oneTimeLogin": "Jednorázové přihlášení",
  "menu.setting.changePassword": "Změna hesla",
  "menu.notifications": "Notifikace",
  "menu.documents": "Dokumenty",
  "menu.documents.new": "Nový dokument",
  language: "Jazyk",
  "language.errorName": "jazyka",
  user: "Uživatel",
  "user.whom": "uživatelů",
  "user.list": "Seznam uživatelů",
  "user.new": "Nový uživatel",
  "user.edit": "Editace uživatele",
  "user.add": "Přidat uživatele",
  "user.add.title": "Přidání stávajícího uživatele",
  "user.add.info":
    "Přidání stávajícího uživatele k této společnosti. Tento uživatel bude mít přístup k informacím dle své aktuální role. Pokud si přejete přístup uživateli odebrat, lze tak učinit kliknutím na ikonu ve sloupci Stav účtu na řádku příslušného uživatele.",
  "user.changePassword": "Změna hesla",
  "user.currentPassword": "Stávající heslo",
  "user.newPassword": "Nové heslo",
  "user.confirmNewPassword": "Potvrzení nového hesla",
  "user.emptyCurrentPassword": "Zadejte stávající heslo!",
  "user.emptyNewPassword": "Zadejte nové heslo!",
  "user.emptyConfirmNewPassword": "Zadejte prosím znovu nové heslo!",
  "user.savePassword": "Změnit heslo",
  "user.resetPassword": "Resetování hesla",
  "user.resetingPassword": "Probíhá resetování hesla",
  "user.signOutByPassword":
    "Z důvodu změny hesla dojde k bezpečnostnímu odhlášení.",
  "user.yourPassword": "Vaše nové heslo je ",
  "user.usersPassword": "Nové heslo uživatele {username} je ",
  "user.passwordQuestion":
    "Přejete si nové heslo odeslat na email uživatele {username} (emailová adresa {email}) nebo jej zobrazit zde?",
  "user.sendToMail": "Odeslat na email",
  "user.showHere": "Zobrazit zde",
  "user.createNew": "Vytvoření nového uživatele",
  "user.save": "Uložit uživatele",
  "user.saved": "Uživatel byl úspěšně uložen.",
  "user.saveError": "Při ukládání uživatele nastala chyba!",
  "user.usedUsername": "Uživatelské jméno je již použité, zvolte prosím jiné.",
  "user.freeUsername": "Uživatelské jméno je volné pro použití.",
  "user.errorName": "uživatele",
  "user.expiredPassword": "Vypršela Vám platnost hesla, změňte si jej prosím!",
  "user.successfulLogin": "Došlo k úspěšnému přihlášení.",
  "user.serverError": "Server není dostupný, zkuste prosím přihlášení později!",
  "user.emptyFirstName": "Zadejte jméno!",
  "user.emptyLastName": "Zadejte příjmení!",
  "user.emptyEmail": "Zadejte email uživatele!",
  "user.emptyUserName": "Zadejte uživatelské jméno!",
  "user.firstname": "Jméno",
  "user.lastname": "Příjmení",
  "user.username": "Uživatelské jméno",
  "user.userrole": "Uživatelská role",
  "user.note": "Interní poznámka",
  "user.email": "E-mail",
  "user.admin": "Administrátor",
  "user.admin.yes": "Uživatel má administrátorské práva",
  "user.admin.no": "Uživatel bez administrátorských práv",
  "user.blocked": "Stav účtu",
  "user.lastLogin": "Datum posledního přihlášení",
  "user.passwordChange": "Datum změny hesla",
  "user.passwordValidity": "Datum expirace hesla",
  "user.generatingPassword": "generování nového hesla",
  "user.noUsers": "tento klient nemá žádné uživatele",
  "user.blockedAccount": "Uživatelský účet je zablokován{suffix}.",
  "user.activedAccount": "Uživatelský účet je aktivní{suffix}.",
  "user.enableAccount": ", kliknutím jej odblokujete",
  "user.disableAccount": ", kliknutím jej zablokujete",
  "user.signIn.message":
    "Webová aplikace pro zákazníky firmy DHL, určená k zadávání a správě objednávek.",
  "user.signIn.contact":
    "V případě problémů kontaktujte náš zákaznický servis na tel. čísle +420 239 018 222.",
  "user.signIn.username": "uživatelské jméno",
  "user.signIn.password": "heslo",
  "user.signIn.emptyUserName": "Vyplňte prosím uživatelské jméno!",
  "user.signIn.emptyPassword": "Vyplňte prosím heslo!",
  "user.signIn.signIn": "Přihlásit se",
  "user.register": "Nová registrace",
  "user.register.title": "Dojde k přesměrování na web e-registrace",
  "user.client.choose": "Vyberte klienta, za kterého chcete pracovat",
  "user.client.loadError": "Při načítání klientů nastala chyba!",
  "user.client.info": "zadejte z-account nebo název klienta",
  "user.company": "Vaše společnost",
  "user.noClients": "uživatel nemá přiřazeného klienta",
  "user.menu": "Uživatelské menu",
  "user.cs": "DHL zákaznický servis",
  customer: "Zákazník",
  "customer.genitiv": "zákazníka",
  "customer.genitivMultiple": "zákazníků",
  "customer.multiple": "Zákazníci",
  "customer.errorName": "zákazníka",
  "customer.edit": "Editace zákazníka",
  "customer.edit.try": "Zákazníka již není možné editovat!",
  "customer.import": "Import zákazníků",
  "customer.export": "Export zákazníků",
  "customer.exportWhom": "zákazníky",
  "customer.list": "Seznam zákazníků",
  "customer.add": "Nový zákazník",
  "customer.save": "Uložit zákazníka",
  "customer.new": "vytvořit nového zákazníka na základě tohoto",
  "customer.noCustomers": "žádní zadaní zákazníci",
  "customer.saveSuccess": "Zákazník byl úspěšně uložen.",
  "customer.saveError": "Při ukládání zákazníka nastala chyba!",
  "customer.bulkDelete": "hromadné smazání zákazníků",
  address: "Adresa",
  "address.errorName": "adresy",
  "address.loadError": "Při načítání adres nastala chyba!",
  "address.search": "Vyhledávání adres",
  "address.search.all": "všechny adresy",
  "address.search.pickup": "pouze nakládkové",
  "address.search.delivery": "pouze vykládkové",
  "address.searchInfo": "zadejte název, ulici, město, kontakt..",
  "address.searchError":
    "Vybranou adresu nelze použít z důvodu nepodporovaného státu pro vybraný produkt!",
  "address.name": "Název",
  "address.emptyName": "Zadejte prosím název!",
  "address.subname": "Sekundární název",
  "address.subnameAlter": "Název 2",
  "address.street": "Ulice",
  "address.emptyStreet": "Zadejte prosím název ulice!",
  "address.streetNumber": "Číslo popisné",
  "address.emptyStreetNumber": "Zadejte prosím číslo popisné!",
  "address.localDestination": "Místní určení",
  "address.localDestinationInfo": "upřesnění adresy (číslo haly, areál, sklad)",
  "address.city": "Město",
  "address.emptyCity": "Zadejte prosím město!",
  "address.zipCode": "PSČ",
  "address.emptyZipCode": "Zadejte prosím PSČ!",
  "address.country": "Stát",
  "address.emptyCountry": "Vyberte prosím stát!",
  "address.contactPerson": "Kontaktní osoba",
  "address.emptyContactPerson": "Zadejte prosím kontaktní osobu!",
  "address.vat": "VAT",
  "address.emptyVat": "Zadejte prosím VAT!",
  "address.contactPhone": "Telefon",
  "address.emptyContactPhone": "Zadejte prosím telefonní kontakt!",
  "address.contactEmail": "Email",
  "address.contactEmail.info":
    "Je možné zadat více emailových adres oddělených středníkem, v celkové délce 128 znaků.",
  "address.insertionDate": "Vytvoření zákazníka",
  "address.changeDate": "Editace",
  "address.emptyPreselection": "Vyberte prosím předvolbu!",
  "address.saveAsCustomer": "Uložit jako zákazníka",
  "address.validation.zipCode.five": "Zadejte PSČ v pětimístném formátu!",
  "address.validation.zipCode.fiveCountry":
    "Zadejte PSČ v pětimístném formátu s prefixem kódu státu a pomlčkou (XX-)!",
  "address.validation.zipCode.four": "Zadejte PSČ v čtyřmístném formátu!",
  "address.validation.zipCode.fourCountry":
    "Zadejte PSČ v čtyřmístném formátu s prefixem kódu státu a pomlčkou (XX-)!",
  "address.validation.zipCode.poland":
    "Zadejte PSČ ve správném formátu (XX-XXX)!",
  "address.validation.zipCode.gbAndDe": "Zadejte PSČ ve správném formátu!",
  "address.validation.zipCode.alphanumeric": "PSČ musí být alfanumerické!",
  "address.validation.zipCode.others":
    "Zadejte PSČ v korektním formátu pro vybranou zemi!",
  "address.validation.phone.eight": "Zadejte telefonní číslo o délce 8!",
  "address.validation.phone.nineTen":
    "Zadejte telefonní číslo o délce 9 nebo 10!",
  "address.validation.phone.nine":
    "Zadejte telefonní číslo v devítimístném formátu!",
  "address.validation.phone.ten": "Zadejte telefonní číslo o délce 10!",
  "address.validation.phone.eleven":
    "Zadejte telefonní číslo o délce 10 nebo 11!",
  "address.validation.phone.tenMore":
    "Zadejte telefonní číslo o délce 10, 11, 12, 13, 14!",
  "address.validation.phone.others":
    "Zadejte telefonní číslo v korektním formátu pro vybranou zemi!",
  "address.import.dataFormat": "Popis datového formátu zákazníka",
  "address.import.info":
    "Pro všechny atributy platí stejné omezení jako při vytváření zásilky pomocí webového formuláře. Atributy nejsou až na výjimky povinné.",
  "address.import.name": "název zákazníka",
  "address.import.subname": "sekundární název zákazníka",
  "address.import.street": "název ulice zákazníka",
  "address.import.streetNumber": "číslo popisné/orientační zákazníka",
  "address.import.localDestination":
    "místní určení (upřesnění adresy) zákazníka",
  "address.import.city": "město zákazníka",
  "address.import.zipCode":
    "PSČ zákazníka; formát dle vybraného státu zákazníka (vnitřní mezery budou smazány)",
  "address.import.country":
    "stát zákazníka; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
  "address.import.contactPerson": "kontaktní osoba zákazníka",
  "address.import.contactPhone":
    "telefonní kontakt na zákazníka; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
  "address.import.contactEmail":
    "emailový kontakt na zákazníka; požadován validní formát emailu",
  "address.self.pickup": "podej",
  "address.self.delivery": "odběr",
  "address.self.type": "Osobní {type} na depu",
  "address.self.depot": "Depo",
  "address.self.emptyDepot": "Vyberte prosím depo DHL pro osobní {type}!",
  "address.self.error": "Při načítání dep nastala chyba!",
  calculator: "Kalkulátor ceny",
  "calculator.warning":
    "Cena nezahrnuje Krizový palivový příplatek. Pro více informací prosím kontaktuje Zákaznické centrum DHL Freight CZ na DHLFreight.cz@dhl.com nebo +420 239 018 222.",
  "calculator.noProducts": "Nemáte žádné povolené produkty!",
  "calculator.info":
    "Omlouváme se, ale kalkulátor je dostupný pouze pro tuzemské (CZ) produkty.",
  "calculator.priceWithoutVat": "{currency} bez DPH",
  "calculator.error": "Při výpočtu ceny nastala chyba!",
  "calculator.checkValues": "Zkontrolujte prosím zadané hodnoty",
  "calculator.priceItems": "přepravné vč. mýta a palivového příplatku",
  "calculator.order": "Objednat přepravu",
  "calculator.emptyValues":
    "Nutno vyplnit povinná pole a kliknout na tlačítko Spočítat",
  "calculator.address.warning": "Cena neobsahuje celní poplatky.",
  "calculator.pickupZip": "PSČ nakládky",
  "calculator.emptyPickupZip": "Zadejte prosím PSČ nakládky!",
  "calculator.deliveryZip": "PSČ vykládky",
  "calculator.emptyDeliveryZip": "Zadejte prosím PSČ vykládky!",
  "calculator.pickupCountry": "Stát nakládky",
  "calculator.emptyPickupCountry": "Vyberte prosím stát nakládky!",
  "calculator.deliveryCountry": "Stát vykládky",
  "calculator.emptyDeliveryCountry": "Vyberte prosím stát vykládky!",
  "calculator.addColli": "Přidat další kus",
  "calculator.insuranceInfo": "zadejte hodnotu zásilky",
  "calculator.height": "Výška",
  "calculator.width": "Šířka",
  "calculator.length": "Délka",
  "calculator.weight": "Hmotnost",
  "calculator.price": "Cena",
  "calculator.price.total": "Celková cena je {price} {currency}",
  "calculator.price.unknown":
    "Pro zásilku s těmito parametry není definován ceník.",
  "calculator.noPrice": "cena není známa",
  "calculator.price.card":
    "(v případě platby kartou se neúčtuje doběrečné, ale kartovné ve výši {price})",
  "calculator.price.B2OC": "Přepravné",
  "calculator.price.COD": "Doběrečné",
  "calculator.price.FUEL": "Palivový příplatek",
  "calculator.price.TOLL": "Mýtné",
  "calculator.price.EB": "P-EUR zpět",
  "calculator.price.ADR": "ADR",
  "calculator.price.INSR": "Připojištění",
  "calculator.price.OGB": "Odvoz starého spotřebiče",
  "calculator.price.FH": "Výnos do patra",
  "calculator.price.CARD": "Platba kartou",
  "calculator.price.B2C": "B2C",
  "calculator.price.PSS": "Peak season",
  "calculator.price.EXTRA": "Extra",
  "calculator.price.ES": "Energetický příplatek",
  "calculator.price.PS": "Prioritní příplatek",
  "calculator.price.DDP": "Delivery term DDP",
  "calculator.price.CSS": "celní služby",
  "calculator.price.DOF": "Poplatek za dokumenty do WA",
  "calculator.price.TSB": "Time slot booking",
  "calculator.price.GG1": "GoGreen Plus Service Charge",
  "calculator.price.GG2": "GoGreen Plus Base",
  "calculator.price.GG3": "GoGreen Plus Smart",
  "calculator.price.GG4": "GoGreen Plus Premium",
  "calculator.price.WD1": "Wrong data",
  consignment: "Zásilka",
  "consignment.edit": "Editace zásilky",
  "consignment.detail": "Detail zásilky",
  "consignment.new": "Nová zásilka",
  "consignment.genitiv": "zásilky",
  "consignment.whom": "zásilku",
  "consignment.genitivMultiple": "zásilek",
  "consignment.noConsignments": "žádné zásilky",
  "consignment.unsent": "Neodeslaná zásilka",
  "consignment.saveWithValidation": "Uložit {saveWhat} s validací formuláře",
  "consignment.errorName": "zásilky",
  "consignment.processError": "Při zpracování zásilky nastala chyba!",
  "consignment.processErrorOnServer":
    "Při zpracování zásilky nastala chyba na serveru.",
  "consignment.tracking": "Sledování zásilek",
  "consignment.track": "Sledování zásilky",
  "consignment.sent": "Zásilky odeslané do DHL",
  "consignment.notSent": "Rozpracované a neodeslané zásilky",
  "consignment.dropConsignments": "Mazání",
  "consignment.dropConsignments.title": "hromadné smazání zásilek",
  "consignment.dropConsignments.noConsignments":
    "Nemáte označené žádné {entity} pro smazání, označte prosím nějaké!",
  "consignment.dropConsignments.drop": "Smazat zásilky",
  "consignment.dropConsignments.end": "kliknutím smažete vybrané zásilky",
  "consignment.exportConsignments": "Export",
  "consignment.exportConsignments.title": "export zásilek do excelu",
  "consignment.exportConsignments.noConsignments":
    "Nemáte označené žádné zásilky pro export, označte prosím nějaké!",
  "consignment.sendConsignments": "Odeslat do DHL",
  "consignment.sendConsignmentsTitle": "odešle validní zásilky do DHL",
  "consignment.printTitle": "zobrazí nabídku tisku k zásilkám",
  "consignment.noCollis": "Zásilka musí obsahovat alespoň jeden kus!",
  "consignment.overWeight":
    "Celková váha zásilky je vyšší než maximální povolená!",
  "consignment.overCalculatedWeight":
    "Celková přepočtená váha zásilky je vyšší než maximální povolená!",
  "consignment.overVolume":
    "Celkový objem zásilky je vyšší než maximální povolený!",
  "consignment.overLoadingMeters":
    "Celkové ložné metry zásilky jsou vyšší než maximální povolené!",
  "consignment.overNotStackable":
    "Pokud je zásilka ADR, tak musí obsahovat alespoň jeden nestohovatelný kus!",
  "consignment.overCollis":
    "Počet kusů zásilky je vyšší než maximální povolený!",
  "consignment.noWrapping":
    "Některý kus zásilky nemá vyplněn obal! Překontrolujte prosím jednotlivé kusy.",
  "consignment.noDescription":
    "Některý kus zásilky nemá vyplněn druh zboží! Překontrolujte prosím jednotlivé kusy.",
  "consignment.badColliDimension":
    "Některý kus zásilky nemá validní rozměry nebo váhu! Překontrolujte prosím jednotlivé kusy.",
  "consignment.state": "Stav",
  "consignment.product": "Produkt",
  "consignment.unknownProduct":
    "Proběhla automatická změna produktu! Zkontrolujte prosím korektnost adres. Dříve vybraný produkt již nemáte aktivní.",
  "consignment.code": "Číslo zásilky",
  "consignment.reference": "Zákaznická reference",
  "consignment.externalCode": "Externí číslo zásilky",
  "consignment.insertionDateTime": "Datum založení",
  "consignment.customerReference": "Reference",
  "consignment.pickup": "Nakládka",
  "consignment.delivery": "Vykládka",
  "consignment.invoice": "Fakturační adresa",
  "consignment.collis": "Nákladové kusy",
  "consignment.countOfCollis": "Počet kusů",
  "consignment.type": "Typ",
  "consignment.cashOnDelivery": "Dobírka",
  "consignment.insurance": "Připojištění",
  "consignment.insurance.recommendation":
    "Překročil jste limit automatického připojištění ({price} {currency}). Doporučujeme zásilku připojistit!\nOhledně více informací prosím kontaktujte zákaznické centrum na emailu DHLFreight.cz@dhl.com nebo na tel: +420 239 018 222.",
  "consignment.insurance.overPrice":
    "Vaše zásilka překračuje povolený limit hodnoty v produktu, pro objednání prosím kontaktujte zákaznické centrum na emailu DHLFreight.cz@dhl.com nebo na tel: +420 239 018 222.\n(Do {limitPrice} {currency} je připojištěno automaticky, v případě {limitPrice} až {maxPrice} {currency} doporučujeme připojistit)",
  "consignment.insurance.overPrice.error": "Překročeno maximum {price}",
  "consignment.status": "Status",
  "consignment.lastTrackMessage": "Stav zásilky",
  "consignment.sentDateTime": "Odeslání dat",
  "consignment.sentByUser": "Odesláno uživatelem",
  "consignment.createDate": "Vznik zásilky",
  "consignment.createdByDhl": "Zásilka byla vytvořena zaměstnancem DHL.",
  "consignment.changedByDhl": "Zásilka byla upravena zaměstnancem DHL.",
  "consignment.sentByDhl": "Zásilka byla odeslána do DHL zaměstnancem DHL.",
  "consignment.freapi": "Zásilka byla odeslána do DHL skrze FREAPI.",
  "consignment.variableSymbol": "Variabilní symbol dobírky",
  "consignment.notPrintedLabel": "Jen zásilky bez vytištěného štítku",
  "consignment.sentDate": "Odeslání zásilky",
  "consignment.codAmount": "Hodnota dobírky",
  "consignment.insurance.withPrice":
    "Zásilka má aktivní připojištění na hodnotu {price} {currency}, poplatek za pojištění je {insurancePrice} {insuranceCurrency}.",
  "consignment.insurance.noPrice":
    "Zásilka má aktivní připojištění, ale nemá zadanou hodnotu!",
  "consignment.insurance.noInsurance": "Zásilka nemá připojištění!",
  "consignment.colli.barcodeWarning":
    "Opravdu si přejete zadat číslo kusu manuálně? Musíte vlastnit číselnou řadu a vložit neduplicitní číslo.",
  "consignment.colli.edit": "Editace kusu",
  "consignment.colli.add": "Zadání nového kusu",
  "consignment.colli.copy": "vytvořit kopii kusu",
  "consignment.colli.adding": "Přidaní nového kusu",
  "consignment.colli.noCollis": "žádné zadané kusy",
  "consignment.colli.biggerThan0": "Hodnota musí být větší než 0!",
  "consignment.colli.lowerThanMax": "Překročena maximální hodnota {max}!",
  "consignment.colli.invalidValue": "špatná hodnota",
  "consignment.colli.count": "Počet kusů",
  "consignment.colli.notStackableCount": "Počet nestohovatelných kusů",
  "consignment.colli.volume": "Objem [m³]",
  "consignment.colli.emptyCount": "Zadejte prosím počet kusů!",
  "consignment.colli.wrapping": "Druh obalu",
  "consignment.colli.wrapping.info":
    "Omezení druhů obalu, kliknutím zobrazíte více.",
  "consignment.colli.wrapping.warn":
    "Vybraný produkt obsahuje omezení obalových materiálů. Číslo vpravo udává maximální počet kusů s daným obalem, číslo v závorce je aktuální počet.",
  "consignment.colli.wrapping.unlimited": "neomezeně",
  "consignment.colli.wrapping.error":
    "Zadané kusy nesplňují podmínky vybraného produktu! Více informací naleznete <a>zde</a>.",
  "consignment.colli.wrapping.errorShort":
    "Zadané kusy nesplňují podmínky vybraného produktu!",
  "consignment.colli.emptyWrapping": "Vyberte prosím druh obalu!",
  "consignment.colli.height": "Výška [cm/ks]",
  "consignment.colli.emptyHeight": "Zadejte prosím výšku!",
  "consignment.colli.overHeight": "Překročen max. rozměr {max} cm!",
  "consignment.colli.width": "Šířka [cm/ks]",
  "consignment.colli.emptyWidth": "Zadejte prosím šířku!",
  "consignment.colli.overWidth": "Překročen max. rozměr {max} cm!",
  "consignment.colli.length": "Délka [cm/ks]",
  "consignment.colli.emptyLength": "Zadejte prosím délku!",
  "consignment.colli.overLength": "Překročen max. rozměr {max} cm!",
  "consignment.colli.weight": "Hmotnost [kg]",
  "consignment.colli.emptyWeight": "Zadejte prosím váhu!",
  "consignment.colli.overWeight": "Překročena maximální váha {max} kg!",
  "consignment.colli.overCalculatedWeight":
    "Překročena maximální přepočtená váha {max} kg!",
  "consignment.colli.weightType1": "Hmotnost 1 kusu",
  "consignment.colli.weightTypeAll": "Hmotnost všech kusů",
  "consignment.colli.weightTypeAllInfo":
    "váha bude rozpočítána poměrem na jednotlivé kusy",
  "consignment.colli.overLoadingMeters":
    "Překročen maximální počet ložních metrů {max} LDM!",
  "consignment.colli.description": "Druh zboží",
  "consignment.colli.emptyDescription": "Zadejte prosím druh zboží!",
  "consignment.colli.manualBarcode": "manuálně zadat číslo kusu",
  "consignment.colli.barcode": "Číslo kusu",
  "consignment.colli.invalidBarcode": "Zadejte validní formát čísla kusu!",
  "consignment.colli.dimensions": "Rozměr kusu [cm]",
  "consignment.colli.barcodeWillBeGenerated":
    "bude automaticky vygenerováno po odeslání",
  "consignment.colli.stackable": "Stohovatelné",
  "consignment.colli.stackable.yes": "Kus je stohovatelný",
  "consignment.colli.stackable.no": "Kus není stohovatelný",
  "consignment.colli.stackable.warning":
    "Prosím určete příznakem nestohovatelnost, který z kusů je ADR.",
  "consignment.colli.loadingMeters": "Ložné metry (LDM)",
  "consignment.colli.emptyLoadingMeters": "Zadejte prosím ložné metry!",
  "consignment.colli.calculatedWeight": "Přepočtená váha [kg]",
  "consignment.template.new": "Nová šablona",
  "consignment.template.edit": "Editace šablony",
  "consignment.template.name": "Šablona",
  "consignment.template.list": "Šablony zásilek",
  "consignment.template.what": "šablon zásilek",
  "consignment.template.errorName": "šablony",
  "consignment.template.whom": "šablonu",
  "consignment.template.insertionDateTime": "Datum vytvoření",
  "consignment.template.templateName": "Název šablony",
  "consignment.template.creator": "Tvůrce šablony",
  "consignment.template.noTemplates": "Název šablony",
  "consignment.template.createNewFromOld":
    "vytvořit novou zásilku na základě této šablony",
  "consignment.template.createNew": "Vytvořit novou šablonu",
  "consignment.template.export": "Export",
  "consignment.template.export.title":
    "Export šablon pro následný import do WA",
  "consignment.template.import": "Import",
  "consignment.template.import.title":
    "Import šablon ve formátu z Exportu šablon",
  "consignment.template.import.error":
    "Při načítání šablon zásilek nastala chyba, zkuste to prosím znovu.",
  "consignment.saveAsTemplate": "Uložit zásilku jako šablonu ",
  "consignment.saveAsTemplateInfo":
    "Na základě dat ze šablony zásilky můžete vytvářet nové zásilky. Při uložení šablony nedojde současně k vytvoření zásilky!",
  "consignment.templateName": "název šablony",
  "consignment.emptyTemplateName": "Zadejte prosím název šablony!",
  "consignment.unknown": "Neznámá zásilka!",
  "consignment.loadError": "Při načítání zásilky nastala chyba",
  "consignment.edit.try": "Zásilku již nelze editovat!",
  "consignment.send.price": "Aktuální ceny přepravy odesílaných zásilek",
  "consignment.send.question":
    "Opravdu si přejete všechny označené zásilky odeslat do DHL? Pokud dojde k odeslání zásilek, nebude u nich již možné nic změnit.",
  "consignment.send.noConsignments":
    "Nemáte označené žádné zásilky pro odeslání, označte prosím nějaké!",
  "consignment.send.error": "Při odesílání zásilek nastala chyba!",
  "consignment.send.withRef": "Zásilka ref. {reference}",
  "consignment.send.withoutRef": "Zásilka bez reference",
  "consignment.send.sendSuccess": "Export dopadl úspěšně.",
  "consignment.send.sendError": "Při exportu nastala chyba!",
  "consignment.send.resultTitle": "Výsledek odeslání dat",
  "consignment.send.countOfValid": "Počet úspěšně odeslaných zásilek:",
  "consignment.send.countOfInvalid": "Počet neodeslaných (chybných) zásilek:",
  "consignment.print.noConsignments":
    "Nemáte označené žádné zásilky pro tisk, označte prosím nějaké!",
  "consignment.print.loadError":
    "Při načítání zásilek nastala chyba, zkuste to prosím znovu!",
  "consignment.print.labelLoadError":
    "Při získávání štítků nastala neočekávaná chyba!",
  "consignment.print.label": "Štítek zásilky",
  "consignment.print.zplLabel":
    "Tisk štítku ve formátu ZPL (labelová tiskárna)",
  "consignment.print.pdfLabel":
    "Tisk štítku formát 4x6.5 – 1 etiketa (labelová tiskárna, pdf)",
  "consignment.print.label3":
    "Tisk štítku formát A4 – 3 etikety (klasická tiskárna)",
  "consignment.print.label4":
    "Tisk štítku formát A4 – 4 etikety (klasická tiskárna)",
  "consignment.print.consignentList": "Seznam zásilek",
  "consignment.print.euroLine": "EuroLine",
  "consignment.print.euroLineCmr": "CMR",
  "consignment.print.euroLineLimitation":
    "Pouze pro zásilky s produktem ELI a ELD",
  "consignment.print.printConsignentList": "Tisk seznamu zásilek",
  "consignment.print.labelPosition": "Vyberte pozici prvního štítku",
  "consignment.list.findInUnsend": "Naleznete ji v neodeslaných zásilkách.",
  "consignment.list.showHistory": "Prohlédnout detailní historii zásilky",
  "consignment.list.hideHistory": "Skrýt detailní historii",
  "consignment.list.copyTitle":
    "Zásilka je kopií jiné, zásilku bude možné odeslat do DHL až po její kontrole/editaci a uložení!",
  "consignment.list.valid": "Zásilka je validní!",
  "consignment.list.invalid": "Zásilka obsahuje chybné nebo nekompletní údaje!",
  "consignment.list.footer.canBeSend": "Tyto zásilky je možné odeslat do DHL!",
  "consignment.list.footer.countOfValid": "Počet validních zásilek",
  "consignment.list.footer.cannotBeSend":
    "Tyto zásilky není možné odeslat do DHL, je nutné doplnit povinné atributy!",
  "consignment.list.footer.countOfInvalid": "Počet nevalidních zásilek",
  "consignment.pod": "POD zásilky",
  "consignment.pod.empty": "POD není doposud dostupné",
  "consignment.pod.show": "Kliknutím zobrazíte POD zásilky",
  "consignment.copy": "Kopie zásilky",
  "consignment.copy.copy": "Kopírování zásilky",
  "consignment.copy.copying": "Probíhá kopírování zásilky..",
  "consignment.copy.success": "Zásilka byla úspěšně zkopírována",
  "consignment.copy.error": "Při kopírování nastala chyba!",
  "consignment.return": "Vytvořit vratnou zásilku",
  "consignment.return.create": "Vratná zásilka",
  "consignment.return.creating": "Probíhá vytváření vratné zásilky..",
  "consignment.return.success": "Vratná zásilka byla úspěšně vytvořena",
  "consignment.return.error": "Při vytváření nastala chyba!",
  "consignment.cancel": "Stornovat zásilku",
  "consignment.cancelled": "Storno",
  "consignment.cancel.info": "Odešle požadavek na stornování zásilky do DHL",
  "consignment.cancel.info.not": "Zásilku již není možné stornovat",
  "consignment.cancel.question": "Opravdu si přejete tuto zásilku stornovat?",
  "consignment.cancel.success": "Zásilka byla úspěšně stornována.",
  "consignment.cancel.done": "Zásilka již byla stornována",
  "consignment.state.pickup": "Zásilka čeká na svoz od odesílatele",
  "consignment.state.delivery": "Zásilka je přepravována k příjemci",
  "consignment.state.delivered": "Zásilka byla úspěšně doručena",
  "consignment.state.cancelled": "Zásilka byla stornována objednatelem.",
  "consignment.state.cancelled.user": "Stornoval uživatel {first} {last}.",
  "consignment.state.return": "Zásilka nebyla doručena",
  "consignment.import.dataFormat": "Popis datového formátu zásilky",
  "consignment.import.dataFormat.attributes":
    "Pro všechny atributy platí stejné omezení jako při vytváření zásilky pomocí webového formuláře. Atributy nejsou až na výjimky povinné.",
  "consignment.import.dataFormat.countries":
    "Státy v adresách je možné zvolit dle aktuální nabídky vzhledem k vybranému produktu. Pro tuzemské produkty (ECD_B2B, ECD_B2C, ELD a ERD) je možná pouze CZ. Množinu zemí pro produkty ECI, ECI_B2C, ERI a ELI Vám sdělí obchodní zástupce, případně je možné si ověřit dostupnost státu ve formuláři pro vytvoření zásilky.",
  "consignment.import.dataFormat.collis":
    'Kusů je možné zadat v rámci jedné zásilky více, kdy se jednotlivé hodnoty atributu kusů oddělují, pro formát xlsx, dle ve formuláři zadaného oddělovače kusů a pro csv uvozením více atributů kusu do znaků "" (příklad zadání více kusů {bold}1;1;1{bold};"karton;paleta;sud";"zdrav. materiál;beton;cihly";;"31;30;99";"30;29;98";"29;28;97";"55;54;53"). Pro kusy platí omezení na jednotlivé rozměry dle aktuálních obchodních podmínek.',
  "consignment.import.dataFormat.flag": "příznak",
  "consignment.import.dataFormat.flagText":
    "V případě doplňkových služeb, kde se zadává pouze {flag}, je možné doplnit hodnoty true, t, ano, a, yes nebo y. V případě vyplnění jiné hodnoty není služba aktivní.",
  "consignment.import.dataFormat.products":
    "kód produktu zásilky, dostupné hodnoty jsou dle Vám dostupných produktů; možné hodnoty jsou ECD_B2C (Home Delivery Domestic), ECD_B2B (DHL Road Freight Standard Domestic (Euroconnect Domestic)), ECI (DHL Road Freight Standard International (Euroconnect International)), ECI_B2C (Home Delivery International), ERI (DHL Road Freight Priority International (Eurapid)), ERD (DHL Road Freight Priority Domestic (Eurapid)), ELD (DHL Road Freight Direct Domestic (Euroline Domestic)) a ELI (DHL Road Freight Direct International (Euroline International))",
  "consignment.import.dataFormat.reference":
    "zákaznická reference; je doporučeno ji vyplnit pro lepší identifikaci nejen výsledku importu dané zásilky",
  "consignment.import.dataFormat.pickup.name": "název odesílatele",
  "consignment.import.dataFormat.pickup.subname":
    "sekundární název odesílatele",
  "consignment.import.dataFormat.pickup.street": "název ulice odesílatele",
  "consignment.import.dataFormat.pickup.streetNumber":
    "číslo popisné/orientační odesílatele",
  "consignment.import.dataFormat.pickup.localDestination":
    "místní určení (upřesnění adresy) odesílatele",
  "consignment.import.dataFormat.pickup.city": "město odesílatele",
  "consignment.import.dataFormat.pickup.zipCode":
    "PSČ odesílatele; formát dle vybraného státu odesílatele (vnitřní mezery budou smazány)",
  "consignment.import.dataFormat.pickup.country":
    "stát odesílatele; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
  "consignment.import.dataFormat.pickup.contactPerson":
    "kontaktní osoba odesílatele",
  "consignment.import.dataFormat.pickup.contactPhone":
    "telefonní kontakt na odesílatele; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
  "consignment.import.dataFormat.pickup.contactEmail":
    "emailový kontakt na odesílatele; požadován validní formát emailu",
  "consignment.import.dataFormat.pickup.save":
    "uložení adresy odesílatele jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je false",
  "consignment.import.dataFormat.delivery.name": "název příjemce",
  "consignment.import.dataFormat.delivery.subname": "sekundární název příjemce",
  "consignment.import.dataFormat.delivery.street": "název ulice příjemce",
  "consignment.import.dataFormat.delivery.streetNumber":
    "číslo popisné/orientační příjemce",
  "consignment.import.dataFormat.delivery.localDestination":
    "místní určení (upřesnění adresy) příjemce",
  "consignment.import.dataFormat.delivery.city": "město příjemce",
  "consignment.import.dataFormat.delivery.zipCode":
    "PSČ příjemce; formát dle vybraného státu odesílatele (vnitřní mezery budou smazány)",
  "consignment.import.dataFormat.delivery.country":
    "stát příjemce; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
  "consignment.import.dataFormat.delivery.contactPerson":
    "kontaktní osoba příjemce",
  "consignment.import.dataFormat.delivery.contactPhone":
    "telefonní kontakt na příjemce; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
  "consignment.import.dataFormat.delivery.contactEmail":
    "emailový kontakt na příjemce; požadován validní formát emailu",
  "consignment.import.dataFormat.delivery.save":
    "uložení adresy přijemce jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je true",
  "consignment.import.dataFormat.invoice.name": "název fakturanta",
  "consignment.import.dataFormat.invoice.subname":
    "sekundární název fakturanta",
  "consignment.import.dataFormat.invoice.street": "název ulice fakturanta",
  "consignment.import.dataFormat.invoice.streetNumber":
    "číslo popisné/orientační fakturanta",
  "consignment.import.dataFormat.invoice.localDestination":
    "místní určení (upřesnění adresy) fakturanta",
  "consignment.import.dataFormat.invoice.city": "město fakturanta",
  "consignment.import.dataFormat.invoice.zipCode":
    "PSČ fakturanta; formát dle vybraného státu odesílatele (vnitřní mezery budou smazány)",
  "consignment.import.dataFormat.invoice.country":
    "stát fakturanta; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
  "consignment.import.dataFormat.invoice.contactPerson":
    "kontaktní osoba fakturanta",
  "consignment.import.dataFormat.invoice.contactPhone":
    "telefonní kontakt na fakturanta; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
  "consignment.import.dataFormat.invoice.contactEmail":
    "emailový kontakt na fakturanta; požadován validní formát emailu",
  "consignment.import.dataFormat.invoice.save":
    "uložení adresy fakturanta jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je false",
  "consignment.import.dataFormat.colli.count": "počet/počty kusů",
  "consignment.import.dataFormat.colli.wrapping":
    "obal/obaly kusů; dostupné hodnoty dle možností ve formuláři pro zadání zásilky",
  "consignment.import.dataFormat.colli.description": "popis/popisy kusů",
  "consignment.import.dataFormat.colli.barcode":
    "kód/kódy kusů; nutné zadat validní formát kódu kusu, pokud nemáte vlastní číselnou řadu nebo si nejste jisti formátem, bude kód automaticky doplněn při odesílání dat do DHL",
  "consignment.import.dataFormat.colli.height":
    "výška/výšky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
  "consignment.import.dataFormat.colli.width":
    "šířka/šířky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
  "consignment.import.dataFormat.colli.length":
    "délka/délky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
  "consignment.import.dataFormat.colli.weight":
    "váha/váhy kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
  "consignment.import.dataFormat.colli.stackability":
    'stohovatelnost/stohovatelnosti kusů; příznak, například pro 3 kusy se zadává jako "a;n;a"',
  "consignment.import.dataFormat.services.codPrice":
    "doběrečná částka; přirozené číslo",
  "consignment.import.dataFormat.services.codCurrency":
    "měna dobírky; ve formátu ISO 4217, nyní dostupné pro CZ (CZK), SK (EUR) a PL (PLN), defaultní hodnota je CZK",
  "consignment.import.dataFormat.services.codVariableSymbol":
    "variabilní symbol dobírky; pouze čísla, maximální délka je 10",
  "consignment.import.dataFormat.services.documentsBack":
    "služba Dokumenty zpět; příznak, pouze pro produkty ECD_B2C a ECD_B2B",
  "consignment.import.dataFormat.services.insurance":
    "služba Připojištění; příznak",
  "consignment.import.dataFormat.services.peur":
    "služba EUR palety zpět; přirozené číslo, pouze pro produkty ECD_B2C a ECD_B2B",
  "consignment.import.dataFormat.services.adr":
    "ADR informace; v případě zadání je zásilka brána jako ADR, vyplňuje se ve formátu - UN číslo, oficiální pojmenování, třída, obalová skupina a množství; pouze pro produkty ECD_B2C a ECD_B2B",
  "consignment.import.dataFormat.services.cash":
    "přepravné placeno hotově; pokud je hodnota vyplněna, vybere se částka za přepravné v hotovosti, možnosti zadání jsou hodnoty 1 (příjemce) a 2 (odesílatel), pouze pro produkty ECD_B2C a ECD_B2B",
  "consignment.import.dataFormat.services.pickupFront":
    "manipulace pomocí hydraulického čela při svozu zásilky; příznak",
  "consignment.import.dataFormat.services.pickupCart":
    "manipulace pomocí paletového vozíku při svozu zásilky; příznak",
  "consignment.import.dataFormat.services.deliveryFront":
    "manipulace pomocí hydraulického čela při rozvozu zásilky; příznak",
  "consignment.import.dataFormat.services.deliveryCart":
    "manipulace pomocí paletového vozíku při rozvozu zásilky; příznak",
  "consignment.import.dataFormat.services.lift":
    "služba Výnos do patra; příznak, pouze pro produkt ECD_B2C",
  "consignment.import.dataFormat.services.oldBack":
    "služba Odvoz starého spotřebiče; příznak, pouze pro produkt ECD_B2C",
  "consignment.import.dataFormat.services.sms":
    "odeslání SMS příjemci zásilky; příznak, v případě nevyplnění je doplněna hodnota z klientského nastavení",
  "consignment.import.dataFormat.services.personalPickup":
    "osobní podání na depu DHL; v případě zadání kódu depa DHL (ve formátu PRG, OSR atp. - dle dostupných CZ dep DHL) je očekáváno vlastní dodání zásilky na vybrané české depo DHL",
  "consignment.import.dataFormat.services.personalDelivery":
    "osobní odběr na depu DHL; v případě zadání kódu depa DHL (ve formátu PRG, OSR atp. - dle dostupných CZ dep DHL) je očekáván vlastní odběr zásilky z vybraného českého depa DHL",
  "consignment.import.dataFormat.services.pod":
    "služba Doklad o dodání (POD); příznak, pouze pro produkt ECI, ECI_B2C a ERI",
  "consignment.import.dataFormat.services.iod":
    "služba Informace o dodání (IOD); příznak, pouze pro produkt ECI a ECI_B2C",
  "consignment.import.dataFormat.services.extraInsurance":
    "služba Připojištění zásilky na 110 % obchodní hodnoty zboží; příznak, pouze pro produkt ECI a ECI_B2C",
  "consignment.import.dataFormat.services.documents":
    "služba Dodání proti dokumentům; příznak, pouze pro produkt ECI a ECI_B2C",
  "consignment.import.dataFormat.services.customs":
    "služba Celní odbavení; příznak, pouze pro produkt ECI a ECI_B2C",
  "consignment.import.dataFormat.services.fdd":
    "FDD; příznak, samotné datum se zadává ve sloupci 61, pouze pro produkt ECI",
  "consignment.import.dataFormat.services.nationalTransportId":
    "EKAER (HU), SENT (PL), UIT (RO); pokud si přejete zadat EKAER/SENT/UIT free, zadejte prosím 'N/A'; maximální délka 20, pouze při doručení do HU/PL/RO, pouze pro produkt ECI, ECI_B2C a ERI",
  "consignment.import.dataFormat.services.nationalTransportIdFree":
    "EKAER free (HU), SENT free (PL), UIT free (RO); příznak, pouze při doručení do HU/PL/RO, pouze pro produkt ECI, ECI_B2C a ERI",
  "consignment.import.dataFormat.services.timeSlotBooking":
    "Time-slot booking; příznak, pouze pro produkt ECI, ECI_B2C, ERD a ERI",
  "consignment.import.dataFormat.services.preAdviseDelivery":
    "Pre-advise delivery; příznak, pouze pro produkt ECI, ECI_B2C, ERD a ERI",
  "consignment.import.dataFormat.services.incoterms":
    "parita (incoterms); výčet hodnot {link}, pouze pro produkt ECI, ECI_B2C a ERI",
  "consignment.import.dataFormat.services.deliveryDate":
    "počáteční datum doručení; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
  "consignment.import.dataFormat.services.price":
    "hodnota zásilky; přirozené číslo",
  "consignment.import.dataFormat.services.priceCurrency":
    "měna hodnoty zásilky; ve formátu ISO 4217; dostupné měny CZK, PLN, USD, EUR; defaultní hodnota je CZK",
  "consignment.import.dataFormat.services.pickupDate":
    "(pro ELD a ELI počáteční) datum svozu; ve formátu d.m.rrrr (den, měsíc, rok); nepovinné, pokud nebude zadáno, přiřadí se automaticky",
  "consignment.import.dataFormat.services.pickupDateTo":
    "koncové datum svozu; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
  "consignment.import.dataFormat.services.deliveryDateTo":
    "koncové datum doručení; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
  "consignment.import.dataFormat.services.free":
    "nepoužíváno - pro budoucí použití",
  "consignment.import.dataFormat.services.note": "poznámka k přepravě",
  "consignment.import.dataFormat.adr.unClass":
    "ADR - Třída nebezpečnosti; povolené hodnoty 1.4, 2.1, 2.2, 3, 4.1, 5.1, 6.1, 8, 9",
  "consignment.import.dataFormat.adr.unCode":
    "ADR - UN číslo; ve formátu XXXX (3333)",
  "consignment.import.dataFormat.adr.chemicalName": "ADR - chemický název",
  "consignment.import.dataFormat.adr.packagingGroup":
    "ADR - obalová skupina; nepovinné, povolené hodnoty I, II, III",
  "consignment.import.dataFormat.adr.packagingType":
    "ADR - typ obalu; povolené hodnoty BBG, BS, CT, CYL, DR, CI, BX, BG, IBC",
  "consignment.import.dataFormat.adr.environmentalHazard":
    "ADR - nebezpečné pro životní prostředí; příznak; nepovinná hodnota",
  "consignment.import.dataFormat.adr.packagingDescription":
    "ADR - popis obalu; nepovinné, doplní se z typu obalu",
  "consignment.import.dataFormat.adr.quantity":
    "ADR - množství ADR látky; desetinné číslo větší než 0",
  "consignment.import.dataFormat.adr.quantityType":
    "ADR - typ množství; povolené hodnoty jsou 1 (omezené množství dle 3.4. LQ) nebo 2 (podlimitní množství dle 1.1.3.6.) nebo 3 (plná - nadlimitní ADR) nebo 4 (vyňaté množství dle 3.5. EQ) nebo 5 (Prázdné obaly)",
  "consignment.import.dataFormat.adr.handlingUnitsQuantity":
    "ADR - počet manipulačních jednotek; přirozené číslo",
  "consignment.import.dataFormat.adr.grossWeight":
    "ADR - celková váha; desetinné číslo větší než 0",
  "consignment.services": "Služby",
  "consignment.services.dateCheckError": "Při kontrole data nastala chyba!",
  "consignment.services.dateCheck.country": "Vyberte prosím zemi svozu",
  "consignment.services.chooseCurrency": "Vyberte prosím měnu!",
  "consignment.services.palletJack": "paletový vozík",
  "consignment.services.tailLift": "hydraulické čelo",
  "consignment.services.price": "Hodnota zásilky",
  "consignment.services.emptyPrice": "Zadejte hodnotu!",
  "consignment.services.emptyInsurance":
    "Pokud si přejete připojistit zásilku, je poplatek za tuto službu je vzhledem k atributům zásilky {insurancePrice} {insuranceCurrency}.",
  "consignment.services.formLoadError":
    "Při načítání Vám dostupných služeb nastala chyba, opakujte prosím načtení formuláře!",
  "consignment.services.pickupDate": "Datum svozu",
  "consignment.services.pickupRange": "Nakládka",
  "consignment.services.deliveryRange": "Vykládka",
  "consignment.services.emptyPickupRange": "Vyberte datum nakládky!",
  "consignment.services.pickupHandling": "Manipulace svoz",
  "consignment.services.deliveryHandling": "Manipulace rozvoz",
  "consignment.services.notes": "Poznámky k přepravě",
  "consignment.services.incoterms": "Parita",
  "consignment.services.emptyIncoterms": "Vyberte prosím paritu!",
  "consignment.services.incotermsError":
    "Při načítání parity nastala chyba, pokud chcete paritu zadat, opakujte prosím načtení formuláře!",
  "consignment.services.deliveryDate": "Datum doručení",
  "consignment.services.fdd": "FDD",
  "consignment.services.pod": "Tisk informace o doručení (POD)",
  "consignment.services.iod": "Informace o dodání (IOD)",
  "consignment.services.extraInsurance":
    "Připojištění zásilky na 110 % obchodní hodnoty zboží",
  "consignment.services.customsClearance": "Celní odbavení",
  "consignment.services.deliveryAgainstDocuments": "Dodání proti dokumentům",
  "consignment.services.documentBack": "Dokumenty zpět",
  "consignment.services.sms": "SMS",
  "consignment.services.peur": "P-EUR zpět",
  "consignment.services.peur.info":
    "Pokud si přejete palety nevracet zvolte prosím u odpovídajících kusů obal 'Paleta' namísto 'P-EUR'.",
  "consignment.services.peurCount": "Počet P-EUR",
  "consignment.services.emptyPeurCount": "Zadejte prosím počet P-EUR!",
  "consignment.services.peurMinCount":
    "Počet P-EUR musí být větší nebo roven počtu kusů s obalem P-EUR!",
  "consignment.services.cashTransportPay": "Platba za přepravné hotově",
  "consignment.services.payer": "Plátce",
  "consignment.services.emptyPayer": "Vyberte prosím plátce!",
  "consignment.services.consignor": "Odesílatel",
  "consignment.services.consignee": "Příjemce",
  "consignment.services.otherAddress": "Jiná fakturační adresa",
  "consignment.services.transportOldAppliance": "Odvoz starého spotřebiče",
  "consignment.services.carryToFloor": "Výnos do patra s pomocí příjemce",
  "consignment.services.carryToFloorInfo":
    "V případě výnosu do patra je maximální hmotnost celé zásilky 80 kg a jednoho kusu 50 kg!",
  "consignment.services.ekaer": "EKAER",
  "consignment.services.ekaer.empty": "Zadejte prosím EKAER",
  "consignment.services.ekaerFree": "EKAER free",
  "consignment.services.sent": "SENT",
  "consignment.services.sent.empty": "Zadejte prosím SENT",
  "consignment.services.sentFree": "SENT free",
  "consignment.services.uit": "UIT",
  "consignment.services.uit.empty": "Zadejte prosím UIT",
  "consignment.services.uitFree": "UIT free",
  "consignment.services.timeSlotBooking": "Time-slot booking",
  "consignment.services.preAdviseDelivery": "Pre-advise delivery",
  "consignment.services.emptyCodAmount": "Zadejte prosím hodnotu dobírky!",
  "consignment.services.emptyCodCurrencies": "Nemáte povoleny žádné měny.",
  "consignment.services.variableSymbol": "Variabilní symbol",
  "consignment.services.emptyVariableSymbol":
    "Zadejte prosím variabilní symbol!",
  "consignment.services.payByCreditCard": "Platba dobírky platební kartou",
  "consignment.services.adr": "ADR",
  "consignment.services.adrInfo":
    "V případě ADR zásilky uveďte: UN číslo, oficiální pojmenování, třídu, obalovou skupinu a množství.",
  "consignment.services.emptyAdrInfo": "Uveďte prosím informace o ADR!",
  "consignment.services.adr.info":
    "Pro možnosti přepravy ADR tříd nebezpečnosti 1.4; 4.2; 4.3; 5.2; je nutné vytvořit poptávku přes Zákaznické centrum na emailové adrese DHLFreight.cz@dhl.com",
  "consignment.services.adr.unClass": "Třída nebezpečnosti",
  "consignment.services.adr.emptyUnClass": "Vyberte prosím UN třídu!",
  "consignment.services.adr.unClassError":
    "Při načítání UN tříd nastala chyba, opakujte prosím načtení formuláře!",
  "consignment.services.adr.unCode": "UN číslo",
  "consignment.services.adr.emptyUnCode": "Zadejte prosím UN číslo!",
  "consignment.services.adr.chemicalName": "Chemický název",
  "consignment.services.adr.emptyChemicalName":
    "Zadejte prosím chemický název!",
  "consignment.services.adr.packagingGroup": "Obalová skupina",
  "consignment.services.adr.emptyPackagingGroup":
    "Vyberte prosím obalovou skupinu!",
  "consignment.services.adr.packagingGroupError":
    "Při načítání obalových skupin nastala chyba, opakujte prosím načtení formuláře!",
  "consignment.services.adr.packagingType": "Typ obalu",
  "consignment.services.adr.emptyPackagingType": "Zadejte prosím typ obalu!",
  "consignment.services.adr.packagingTypeError":
    "Při načítání typů obalů nastala chyba, opakujte prosím načtení formuláře!",
  "consignment.services.adr.packagingDescription": "Popis obalu",
  "consignment.services.adr.emptyPackagingDescription":
    "Zadejte prosím popis obalu!",
  "consignment.services.adr.quantity": "Množství ADR látky",
  "consignment.services.adr.quantity.extended": "Celkové množství ADR látky",
  "consignment.services.adr.quantity.over":
    "Celkové množství ADR látky je větší než maximální povolené.",
  "consignment.services.adr.quantity.over.grossWeight":
    "Celkové množství ADR látky je větší než celková váha všech ADR kusů.",
  "consignment.services.adr.emptyQuantity":
    "Zadejte prosím množství ADR látky!",
  "consignment.services.adr.handlingUnitsQuantity":
    "Počet manipulačních jednotek",
  "consignment.services.adr.handlingUnitsQuantity.over":
    "Celkový počet ADR manipulativních jednotek je větší než maximální povolený.",
  "consignment.services.adr.emptyHandlingUnitsQuantity":
    "Zadejte prosím počet manipulačních jednotek!",
  "consignment.services.adr.grossWeight": "Celková váha",
  "consignment.services.adr.grossWeight.over":
    "Celková váha všech ADR kusů je větší než maximální povolená.",
  "consignment.services.adr.emptyGrossWeight": "Zadejte prosím celkovou váhu!",
  "consignment.services.adr.grossWeight.summary": "Celková váha LQ",
  "consignment.services.adr.environmentalHazard":
    "Nebezpečné pro životní prostředí",
  "consignment.services.adr.environmentalHazard.empty": "Vyberte prosím",
  "consignment.services.adr.quantityType": "Typ množství",
  "consignment.services.adr.limitedQuantity": "Omezené množství dle 3.4. LQ",
  "consignment.services.adr.exemptedQuantity": "Vyňaté množství dle 3.5 EQ",
  "consignment.services.adr.emptyPackage": "Prázdné obaly",
  "consignment.services.adr.fullAdrQuantity": "Plná - nadlimitní ADR",
  "consignment.services.adr.underLimitQuantity":
    "Podlimitní množství dle 1.1.3.6.",
  "consignment.services.adr.add": "Přidat ADR kus",
  "consignment.services.adr.drop": "Odebrat ADR kus",
  "consignment.product.loadError": "Při načítání produktů nastala chyba.",
  "consignment.product.chooseProduct": "Pro pokračování vyberte produkt.",
  "consignment.product.chosenProduct": "Vámi vybraný produkt zásilky",
  "consignment.product.choose": "Vyberte produkt zásilky",
  "consignment.product.cannotLoad": "Nepodařilo se načíst dostupné produkty.",
  "invoice.list": "Seznam faktur",
  "invoice.export": "Export faktur",
  "invoice.what": "faktur",
  "invoice.errorName": "faktury",
  "invoice.code": "Číslo",
  "invoice.codeFull": "Číslo faktury",
  "invoice.noInvoices": "žádné dostupné faktury",
  "invoice.state": "Stav",
  "invoice.paid": "Faktura byla zaplacena",
  "invoice.canceled": "Faktura byla stornována",
  "invoice.notPaid": "Faktura nebyla prozatím zaplacena",
  "invoice.creditNote": "dobropis",
  "invoice.notPaidAndAfterDueDate":
    "Faktura není zaplacena a je již po splatnosti",
  "invoice.invoiceType": "Druh",
  "invoice.issueDate": "Datum vystavení",
  "invoice.taxableDate": "Datum zdanitelného plnění",
  "invoice.dueDate": "Datum splatnosti",
  "invoice.payDate": "Datum úhrady",
  "invoice.daysAfterDueDate": "Počet dnů po splatnosti",
  "invoice.amount": "Částka",
  "invoice.currency": "Měna",
  "invoice.afterPayDate": "Pouze faktury po splatnosti",
  "invoice.onlyNotPaid": "Pouze nezaplacené faktury",
  "prints.zebraList": "Zebra štítky",
  "prints.labelList": "Seznam štítků",
  "prints.invoiceList": "Seznam faktur",
  "prints.invoiceList.noInvoices": "Žádné faktury k tisku!",
  "prints.addressList": "Seznam zákazníků",
  "prints.addressList.noAddresses": "Žádní zákazníci k tisku!",
  "prints.pages": "strana {pageNumber} z {totalPages}",
  "prints.printedOn": "Vytištěno: {dt}",
  import: "Import nových {what}",
  "import.format": "Šablona ve formátu {type}",
  "import.message":
    "Aktualizujte si prosím šablonu, došlo k přidání ADR atributů a stohovatelnosti kusů, děkujeme.",
  "import.download": "Klikněte pro stažení",
  "import.dataFormat": "Datový formát",
  "import.cancelLoading": "Nahrávání bylo zrušeno!",
  "import.fileTypes": "Podporované formáty jsou csv a xlsx.",
  "import.result": "Výsledek importu",
  "import.uploadAborted": "Nahrávání bylo zrušeno!",
  "import.supportedFormats": "Podporované formáty jsou csv a xlsx.",
  "import.templateResult": "Název šablony: {templateName} (šablona č.{row})",
  "import.referenceResult":
    "Reference zásilky: {customerReference} (řádek {row})",
  "import.customerResult": "Zákazník {name} (řádek {row})",
  "import.entityResult": "{entity} na řádku {row}",
  "import.success": "Import dopadl úspěšně.",
  "import.error": "Při importování {what} nastal problém!",
  "import.fileType": "Typ souboru",
  "import.containsHeader": "Soubor obsahuje hlavičku",
  "import.workbookNUmber": "Číslo sešitu",
  "import.emptyWorkbookNUmber": "Vyplňte prosím číslo sešitu!",
  "import.filePassword": "Heslo k souboru",
  "import.colliDelimiter": "Oddělovač atributů kusu/ů",
  "import.emptyColliDelimiter": "Vyplňte prosím oddělovač kusů!",
  "import.coding": "Kódování",
  "import.emptyCoding": "Vyberte prosím kódování souboru!",
  "import.firstDelimiter": "středník",
  "import.delimiter": "Oddělovač",
  "import.emptyDelimiter": "Vyplňte prosím oddělovač!",
  "import.uploadSuccess": "Soubor {name} byl úspěšně nahrán.",
  "import.uploadError": "Při zpracování souboru nastala chyba: {message}",
  "import.uploadErrorInfo":
    "Zkontrolujte, zda používáte nejnovější šablonu, mohlo dojít k přidání nových atributů.",
  "import.uploadFailure": "Nahrávání souboru {name} selhalo.",
  "import.clickOrDrag": "Zde klikněte nebo přetáhněte soubor",
  "export.pdf": "ve formátu pdf",
  "export.xlsx": "ve formátu xlsx",
  "export.error": "Při exportu dat nastala chyba.",
  "export.noEntitiesAll":
    "Nemáte vybrané žádné {entity}, přejete si exportovat všechny načtené {entity}?",
  "export.noEntities":
    "Nemáte vybrané žádné {entity}, zkuste změnit atributy filtru.",
  tracking: "SLEDOVÁNÍ ZÁSILEK",
  "tracking.error": "Chyba",
  "tracking.emptyCode":
    "Zadejte prosím číslo zásilky, číslo kusu nebo referenci!",
  "tracking.placeholder": "zadejte číslo zásilky, číslo kusu nebo referenci",
  "tracking.findNew": "Hledat novou zásilku",
  "tracking.serverError": "Omlouváme se, ale server je momentálně nedostupný.",
  "tracking.yourConsignment": "VAŠE ZÁSILKA",
  "tracking.place": "Místo",
  "tracking.dateTime": "Čas",
  "tracking.message": "Status",
  "tracking.transportDetail": "Detail přepravy",
  "tracking.actualState": "Aktuální stav zásilky",
  "tracking.actualState.message": "Stav zásilky",
  "tracking.actualState.dateTime": "Místo a čas",
  "tracking.information": "Informace o zásilce",
  "tracking.consignment.code": "Kód zásilky",
  "tracking.consignment.orderCode": "Kód objednávky {orderCode}",
  "tracking.consignment.sender": "Místo odesílatele",
  "tracking.consignment.customerReference": "Zákaznická reference",
  "tracking.consignment.countOfCollis": "Počet kusů",
  "tracking.consignment.weight": "Váha",
  "tracking.consignment.cashOnDelivery": "Dobírka",
  notification: "Notifikace",
  "notification.list": "Notifikace",
  "notification.new": "Nová notifikace",
  "notification.edit": "Editace notifikace",
  "notification.createNew": "Vytvořit novou notifikaci",
  "notification.unknown": "Neznámá notifikace!",
  "notification.name.def": "Notifikace",
  "notification.name": "Název notifikace",
  "notification.name.empty": "Zadejte název.",
  "notification.title.cz": "Titulek CZ",
  "notification.title.cz.empty": "Zadejte CZ titulek.",
  "notification.title.en": "Titulek EN",
  "notification.title.en.empty": "Zadejte EN titulek.",
  "notification.title.pl": "Titulek PL",
  "notification.title.pl.empty": "Zadejte PL titulek.",
  "notification.message.cz": "Obsah CZ",
  "notification.message.en": "Obsah EN",
  "notification.message.pl": "Obsah PL",
  "notification.message.empty": "Vyplňte prosím CZ a EN obsah!",
  "notification.insertionDateTime": "Datum vytvoření",
  "notification.errorName": "notifikace",
  "notification.notificationName": "Název notifikace",
  "notification.creator": "Tvůrce notifikace",
  "notification.what": "notifikací",
  "notification.noNotifications": "žádné notifikace",
  "notification.displayToUsers.filter": "Pouze zobrazené uživatelům",
  "notification.displayToUsers": "Zobrazeno uživatelům",
  "notification.displayToUsers.yes": "Zobrazuje se uživatelům",
  "notification.displayToUsers.no": "Skryto před uživateli",
  "notification.validTo": "Zobrazovat do",
  "notification.validTo.info":
    "Datum a čas, do kterého se má tato notifikace uživatelům zobrazovat.",
  "notification.validTo.to": " do {date}",
  "notification.changeDateTime": "Poslední úprava",
  "notification.changer": "Úpravce notifikace",
  "notification.save.success": "Notifikace byla úspěšně uložena.",
  "notification.save.error": "Při ukládání notifikace nastala chyba!",
  "notification.confirm": "Potvrzuji přečtení",
  "notification.later": "Přečíst později",
  "notification.read": "kliknutím zobrazíte nepřečtené notifikace",
  "contracts.header": "Obchodní podmínky a smlouvy",
  "contracts.error":
    "Při načítání klientských dat nastala chyba, zkuste to prosím znovu.",
  "contracts.terms": "Obchodní podmínky a registrace",
  "contracts.terms.agree":
    "Souhlas s obchodními podmínkami je platný od {date}.",
  "contracts.terms.here": "aktuální obchodní podmínky pro tisk",
  "contracts.terms.check": "souhlasím s obchodními podmínkami DHL Freight CZ",
  "contracts.terms.check.contract":
    "Souhlas není možné odvolat z důvodu uzavřené smlouvy.",
  "contracts.terms.check.no":
    "Souhlas byl odvolán, není možné odesílat zásilky do DHL.",
  "contracts.terms.check.agree":
    "V případě odvolání souhlasu dojde k blokaci odesílání zásilek do DHL.",
  "contracts.terms.check.agree.no":
    "V případě souhlasu dojde k povolení odesílání zásilek do DHL.",
  "contracts.terms.check.question":
    "Pokud odeberete souhlas, dojde k zablokování odesílání zásilek do DHL!",
  "contracts.terms.check.question.title":
    "Opravdu si přejete odvolat souhlas s obchodními podmínkami?",
  "contracts.terms.check.question.success":
    "Souhlas s obchodmími podmínkami DHL Freight byl odebrán!",
  "contracts.terms.check.question.error":
    "Při odebírání souhlasu nastala chyba, zkuste to prosím znovu!",
  "contracts.contract": "Smlouvy a ceníky",
  "contracts.contract.pricelist.ecd": "aktuální všeobecný ceník produktů ECD",
  "contracts.contract.pricelist.eci": "aktuální všeobecný ceník produktů ECI",
  "contracts.contract.no": "Žádná smlouva není dostupná.",
  "oneTimeLogin.list": "Jednorázové přihlášení",
  "oneTimeLogin.errorName": "jednorázového přihlášení",
  "oneTimeLogin.new": "Nové přihlášení",
  "oneTimeLogin.new.long": "Nové jednorázové přihlášení",
  "oneTimeLogin.new.title": "Vytvoření nového jednorázového přihlášení",
  "oneTimeLogin.save": "Vytvořit jednorázové přihlášení",
  "oneTimeLogin.lastLogin": "Datum přihlášení",
  "oneTimeLogin.used": "Přihlášení bylo využito.",
  "oneTimeLogin.validity": "Stav",
  "oneTimeLogin.invalid":
    "Jednorázové přihlášení expirovalo. Platnost do {date}.",
  "oneTimeLogin.deleted": "Přihlášení bylo zrušeno. Platnost do {date}.",
  "oneTimeLogin.valid":
    "Platnost do {date}, kliknutím odešlete sms znovu a navýšíte čas pro přihlášení.",
  "oneTimeLogin.inserter": "Vytvoření",
  "oneTimeLogin.changer": "Úprava",
  "oneTimeLogin.deleter": "Storno",
  "oneTimeLogin.drop": "Kliknutím zrušíte přihlášení",
  "oneTimeLogin.drop.success": "Jednorázové přihlášení bylo úspěšně zrušeno.",
  "oneTimeLogin.drop.dropped": "Již bylo zrušeno",
  "oneTimeLogin.drop.error": "Při pokusu zrušení nastala chyba!",
  "oneTimeLogin.resend.success": "SMS byla úspěšně znovuodeslána.",
  "oneTimeLogin.resend.limit": "Byl překročen limit odeslání sms.",
  "oneTimeLogin.resend.unknown": "Neznámý požadavek o přihlášení.",
  "oneTimeLogin.resend.error": "Při pokusu o odeslání sms nastala chyba.",
  "oneTimeLogin.whom": "jednorázových přihlášení",
  "oneTimeLogin.noUsers": "tento klient nemá jednorázové přihlášení",
  "oneTimeLogin.phone": "Telefonní číslo",
  "oneTimeLogin.phone.empty": "Zadejte telefonní číslo",
  "oneTimeLogin.code": "Kód",
  "document.new": "Nový dokument",
  "document.edit": "Editace dokumentu",
  "document.load.error": "Při načítání dokumentu nastala chyba",
  "document.current": "Aktuální klient",
  "document.clients": "Výčet klientů",
  "document.clients.info":
    "vložte prosím níže soubor s jedinečnými identifikátory klienta (IČO, DIČ, EVO Contract, ZAccount) oddělenými středníkem, čárkou nebo enterem",
  "document.upload.button": "Nahrát přílohu (maximum {max})",
  "document.upload.success": "Příloha {name} byla úspěšně nahrána.",
  "document.upload.response":
    "Při zpracování přílohy nastala chyba: {message}.",
  "document.upload.error": "Nahrávání přílohy {name} selhalo.",
  "document.upload.exceed":
    "Maximální počet příloh je {max}, pokud si přejete nahrát další, smažte předchozí.",
  "document.onlyTxt": "Je povoleno nahrávat pouze .txt soubory",
  "document.file": "Soubor",
  "document.url": "Odkaz",
  "document.name": "Název dokumentu pro klienta",
  "document.name.client": "Název",
  "document.desc": "Popis dokumentu",
  "document.type": "Typ dokumentu",
  "document.type.miss": "Vyberte prosím typ dokumentu",
  "document.type.error": "Při načítání typů dokumentu nastala chyba",
  "document.TermsAndConditions": "Obchodní podmínky",
  "document.PriceList": "Ceník",
  "document.Others": "Ostatní",
  "document.validFrom": "Platné od",
  "document.validTo": "Vyjádření do",
  "document.url.validation": "Zadejte platnou URL začínající na https.",
  "document.autoResult": "Po uplynutí platnosti",
  "document.autoResult.confirm": "Automaticky schválit",
  "document.autoResult.reject": "Automaticky odmítnout",
  "document.blockOnReject": "V případě zamítnutí zablokovat klienta",
  "document.email": "Emailová notifikace",
  "document.email.info":
    "Je možné zadat více emailových adres oddělených středníkem.",
  "document.email.confirm": "Informovat při souhlasu",
  "document.email.reject": "Informovat při odmítnutí",
  "document.create.success": "Dokument byl úspěšně vytvořen.",
  "document.create.badData": "Vyplněné data nejsou korektní.",
  "document.create.noClients": "Ze souboru se nepodařilo načíst žádné klienty",
  "document.create.notFoundClients": "Někteří zadaní klienti nebyli nalezeni.",
  "document.create.fileError":
    "Nepodařilo se odeslat soubor, zkuste pro prosím znovu.",
  "document.create.error": "Při vytváření dokumentu nastala chyba",
  "document.list": "Dokumenty",
  "document.notProcessed": "Dokumenty ke zpracování",
  "document.processed": "Zpracované dokumenty",
  "document.what": "dokumentů",
  "document.notProcessed.noData": "Nemáte žádné dokumenty ke zpracování",
  "document.processed.noData": "Nemáte žádné dokumenty",
  "document.blockOnReject.true":
    "Pokud odmítnete tento dokument, dojde k zablokování přístupu ke službám DHL Freight CZ.",
  "document.blockOnReject.false": "Dokument ke zpracování",
  "document.inserter": "Vložil",
  "document.result": "Odpověď",
  "document.confirmed": "Dokument byl odmítnut.",
  "document.rejected": "Dokument byl schválen.",
  "document.confirm": "Kliknutím akceptujete dokument",
  "document.reject": "Kliknutím odmítnete dokument",
  "document.resolve.success": "Dokument byl úspěšně zpracován.",
  "document.resolve.error": "Při zpracování dokumentu nastala chyba.",
  "document.resolve.logout":
    "Váš účet byl zablokován z důvodu zamítnutí důležitého dokumentu DHL.",
  "document.download": "Kliknutím stáhnete dokument.",
  "document.link.title": "Kliknutím zobrazíte dokument",
  "document.confirm.role":
    "Ve stávající roli nemáte možnost zpracovat dokument",
  "document.validTo.approve":
    "Po tomto datu bude dokument automaticky schválen.",
  "document.validTo.reject":
    "Po tomto datu bude dokument automaticky zamítnut.",
  "document.read": "máte dokumenty ke zpracování",
  "document.read.info": "Máte dokumenty ke zpracování. {second}",
  "document.read.info.user":
    "Informujte prosím uživatele s rolí administrátor o této skutečnosti.",
  "document.read.info.admin":
    "Pro zpracování přejděte do sekce dokumentu v levém menu.",
  "document.clients.notFound": "Nebyly nalezeni klienti: {clients}",
  "document.drop": "Zrušit přiřazení dokumentu pro tohoto klienta",
  "document.drop.success":
    "Pro stávajícího klienta byl dokument úspěšně zrušen.",
  "document.drop.error": "Při rušení dokumentu nastala chyba.",
};
